<template>
  <div class="banner-container">
    <ml-loading v-if="loading" />
    <template v-else>
      <swiper
        v-if="banners.length > 0"
        :options="swiperOption"
        ref="mySwiper"
        @slideChange="changeBanner"
      >
        <swiper-slide
          v-for="banner in banners"
          :key="banner.id"
          class="banner-item"
        >
          <img
            @click="navigateTo(navigateTo.iosLink)"
            :src="banner.imgUrl"
            alt=""
          />
        </swiper-slide>
      </swiper>
      <ul class="dot-container">
        <li
          v-for="(banner, index) in banners"
          :key="banner.id"
          :class="{
            'dot-item-active': currentIndex === index
          }"
          class="dot-item"
        ></li>
      </ul>
    </template>
  </div>
</template>

<script>
import { getHomeBanner, getVideoBanner } from "@/api/banner";

export default {
  name: "Banner",
  props: {
    type: {
      type: String,
      default: "home"
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      },
      currentIndex: 0,
      banners: [],
      loading: false,
      error: null
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.banners = [];
      this.loading = true;
      switch (this.type) {
        case "home":
          this.banners = await getHomeBanner();
          this.loading = false;
          break;
        case "video":
          this.banners = await getVideoBanner();
          this.loading = false;
          break;
      }
    },
    changeBanner() {
      if (!Number.isNaN(this.swiper.realIndex)) {
        this.currentIndex = this.swiper.realIndex;
      }
    },
    navigateTo(url) {
      if (url) {
        window.open(url);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-container {
  height: 174px;
  overflow: auto;
  .banner-item {
    overflow: hidden;
    width: 335px;
    height: 140px;
    border-radius: 6px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.dot-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 15px;
  padding: 0;
  .dot-item {
    margin: 0 3px;
    width: 4px;
    height: 4px;
    background: rgba(51, 51, 51, 1);
    border-radius: 2px;
    opacity: 0.4;
    transition: width 0.5s ease 0s;
  }
  .dot-item-active {
    width: 12px;
  }
}
</style>
